import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import JalaliUtils from "@date-io/jalaali";
import MaterialThemeProvider from "../Component/Material/MaterialThemeProvider";
import ScheduleModal from "../Component/Modals/ScheduleModal";
import MaterialWrapper from "../Component/Material/MaterialWrapper";
import ReviewModal from "../Component/Dashboard/DashboardListItem/ReviewModal";
import SuspendModal from "../Component/Modals/SuspendModal";

const Container = styled.div`
  display: ${(props) => props.display || "flex"};
  justify-content: center;
  min-width: 100vw !important;
  width: 100vw !important;
  max-width: 100vw !important;
  background-color: ${(props) => props.theme.wrapper};
  min-height: 100vh !important;
  height: 100%;
  color: ${(props) => props.color || props.theme.white};
  overflow-x: hidden;
  box-sizing: border-box;
  padding-top: 0;
  transition: padding-top 300ms ease;
  font-family: Fa_IRANSans;
`;
const Wrapper = (props) => {
  const theme = useContext(ThemeContext);
  const [notificationMode, setNotificationMode] = React.useState(
    window.notificationOpen !== true
  );

  function onNotificationCollapse() {
    setNotificationMode(false);
  }

  React.useEffect((_) => {
    document.addEventListener("notificationCollapsed", onNotificationCollapse);
    return (_) =>
      document.removeEventListener(
        "notificationCollapsed",
        onNotificationCollapse
      );
  }, []);
  return (
    <MaterialWrapper>
      <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
        <ScheduleModal />
        <SuspendModal />
      </MuiPickersUtilsProvider>
      <MaterialThemeProvider>
        <ReviewModal />
      </MaterialThemeProvider>
      <Container
        {...props}
        theme={theme}
        className={`${props.className} ${
          notificationMode ? "body_notificationMode" : ""
        }`}
      >
        {props.children}
      </Container>
    </MaterialWrapper>
  );
};

export default Wrapper;
